import { defineStore } from "pinia";
import { ComputedRef, computed, ref } from "vue";
import { smsCreditsService } from "@/services/sms-credits.service";
import { DAY_FILTER } from "@/components/days-dropdown/day-dropdown";
import { PRIMARY_FILTER } from "@/views/account-management/credit-usage/components/credit-usage-filters-chart-view.vue";

enum VIEW_TYPE {
  CHART = "CHART",
  GRID = "GRID",
}

class ChartFilters {
  primaryFilter: number | DAY_FILTER | PRIMARY_FILTER;
  granularityFilter: string;
  toDateTime?: string;
  fromDateTime?: string;
  filterUserIds?: object[];

  constructor() {
    this.primaryFilter = 1;
    this.granularityFilter = "HOURS";
    this.filterUserIds = [];
  }
}

class CreditUsageModuleState {
  chartFilters: ChartFilters;
  viewType: string;
  smsCreditsCount: number | DAY_FILTER;

  constructor() {
    this.chartFilters = new ChartFilters();
    this.viewType = VIEW_TYPE.GRID;
    this.smsCreditsCount = 0;
  }
}

export const useCreditUsageStore = defineStore("creditUsage", () => {
  // STATES
  const chartFilters = ref<CreditUsageModuleState["chartFilters"]>(
    new ChartFilters(),
  );
  const viewType = ref<CreditUsageModuleState["viewType"]>(VIEW_TYPE.GRID);
  const smsCreditsCount = ref<CreditUsageModuleState["smsCreditsCount"]>(0);

  // ACTIONS
  const setCreditChartFilters = (
    chartFilter: CreditUsageModuleState["chartFilters"],
  ) => {
    chartFilters.value = chartFilter;
  };

  const setViewType = (viewTypeValue: string) => {
    viewType.value = viewTypeValue;
  };

  const setSmsCreditsCount = async () => {
    const { data } = await smsCreditsService.getCredistStats();
    smsCreditsCount.value = (data ?? 0).toLocaleString();
  };

  // GETTERS
  const getChartFilter: ComputedRef<ChartFilters> = computed(
    () => chartFilters.value,
  );
  const getViewType: ComputedRef<CreditUsageModuleState["viewType"]> = computed(
    () => viewType.value,
  );
  const getSmsCreditsCount: ComputedRef<number | DAY_FILTER> = computed(
    () => smsCreditsCount.value,
  );

  return {
    getChartFilter,
    getViewType,
    getSmsCreditsCount,
    setCreditChartFilters,
    setViewType,
    setSmsCreditsCount,
  };
});
